import { InfluencerProfileTemplates } from '@anytag/shared-organisms';

export const InfluencerAccountProfile = () => <InfluencerProfileTemplates />;
